import { getContactPerson, } from '@debbie/common/dist/customers/index.js';
import { Entity, phoneToString } from '@debbie/common/dist/index.js';
import { filterPropertyTypes } from '@debbie/common/dist/properties/index.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { getMentionSuggestions, toEditorMentions, } from '@debbie/common/dist/templates/suggestions.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { useNewInteraction } from '@debbie/cortex/dist/newInteractions/index.js';
import { autocallInitialState } from '@debbie/cortex/dist/newInteractions/types.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../theme.js';
import { PARSE_RESULT_TYPE, parseText } from '../../utils/templates.js';
import { Badge, Button } from '..//index.js';
import AutoCallActions from '../AutoCallActions.js';
import NewEditor from '../editor/Editor.js';
import { isEditorEmpty, useEditorState } from '../editor/hooks.js';
import InteractionFooter from './InteractionFooter.js';
import TemplateSearch from './TemplateSearch.js';
const AutoCallInteraction = (props) => {
    const { caseId } = props.case;
    const [interaction, setInteraction] = useNewInteraction(caseId);
    const autocall = interaction.autocall;
    const tenant = useTenant();
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    const lang = useSelector((s) => s.lang);
    const contentState = useEditorState();
    const mentionSuggestions = getMentionSuggestions(lang, TemplateType.AUTOCALL, propertyTypes
        ? filterPropertyTypes(propertyTypes, Entity.Case, props.case?.caseGroup?.id || null).concat(filterPropertyTypes(propertyTypes, Entity.Customer), filterPropertyTypes(propertyTypes, Entity.Creditor))
        : undefined, tenant);
    const contactPerson = getContactPerson(props.customer, props.case);
    const toPhone = contactPerson?.details.phone;
    const registerAutoCallMutation = useMutation(async () => {
        await c.newInteractions.registerAutoCall(caseId, Entity.Case, autocall, {
            voiceName: 'Mads',
            transcript: parseText(contentState.html, mentionSuggestions, PARSE_RESULT_TYPE.TEXT),
            fromCountryCode: '45',
            fromPhoneNumber: '54543899',
            toCountryCode: toPhone?.locale,
            toPhoneNumber: toPhone?.number,
            actions: autocall.actions,
        }, 'caseworker');
        // TODO: Wail for initialstate to be updated
        contentState.overwriteEditorContent(autocallInitialState.content);
    });
    const phoneValidation = contactPerson &&
        contactPerson.details.phoneValidations &&
        contactPerson.details.phoneValidations.find((pV) => (pV.phone && pV.phone.number) ==
            (contactPerson.details.phone && contactPerson.details.phone.number) &&
            (pV.phone && pV.phone.locale) ==
                (contactPerson.details.phone && contactPerson.details.phone.locale));
    return (React.createElement(React.Fragment, null,
        React.createElement(TemplateSearch, { interaction: autocall, templateType: TemplateType.AUTOCALL, case: props.case, customer: props.customer, onChange: (state) => {
                contentState.overwriteEditorContent(state);
            } }),
        React.createElement("div", null,
            []
                .concat(phoneValidation &&
                phoneValidation.originalCarrier &&
                phoneValidation.originalCarrier.name
                ? {
                    content: phoneValidation.originalCarrier.name,
                }
                : [])
                .concat(phoneValidation &&
                phoneValidation.originalCarrier &&
                phoneValidation.originalCarrier.networkType
                ? {
                    content: lang.phoneValidation[phoneValidation.originalCarrier.networkType] || phoneValidation.originalCarrier.networkType,
                }
                : [])
                .concat(phoneValidation &&
                phoneValidation.roaming &&
                phoneValidation.roaming.status &&
                phoneValidation.roaming.status != 'not_roaming'
                ? {
                    content: lang.phoneValidation[phoneValidation.roaming.status] || phoneValidation.roaming.status,
                }
                : [])
                .concat(phoneValidation &&
                phoneValidation.reachable &&
                !['reachable', 'unknown'].includes(phoneValidation.reachable)
                ? {
                    content: phoneValidation.reachable,
                }
                : [])
                .map((tag) => (React.createElement(Badge, { theme: THEME.COLOR_ACCENT, style: { marginRight: '5px' } }, tag.content))),
            React.createElement("p", null, contactPerson && toPhone && phoneToString(toPhone))),
        React.createElement(NewEditor, { hideControls: true, mentions: toEditorMentions(mentionSuggestions), mentionSuggestions: mentionSuggestions, onChange: (html) => {
                contentState.onChange(html);
                setInteraction('autocall', { ...autocall, content: html });
            }, initialContent: contentState.editorContent }),
        React.createElement("div", null,
            React.createElement(AutoCallActions, { actions: autocall.actions || [], onChange: (actions) => {
                    setInteraction('autocall', {
                        ...autocall,
                        actions: actions,
                    });
                } }),
            React.createElement("p", { onClick: () => {
                    setInteraction('autocall', {
                        ...autocall,
                        actions: (autocall.actions || []).concat({
                            procedureId: 'f892b601-2d51-46e6-901c-1b90556dcdf3', //empty procedure
                            id: Math.random().toLocaleString(),
                        }),
                    });
                }, style: {
                    cursor: 'pointer',
                    textTransform: 'uppercase',
                    fontWeight: 900,
                    color: THEME.COLOR_ACCENT,
                    marginTop: '0px',
                } }, lang.autoCall.addAction)),
        React.createElement(InteractionFooter, { error: registerAutoCallMutation.error, primary: React.createElement(Button, { size: "small", loading: autocall.loading || registerAutoCallMutation.isLoading, disabled: isEditorEmpty(contentState.html), onClick: () => registerAutoCallMutation.mutate() }, lang.autoCall.call) })));
};
export default AutoCallInteraction;
//# sourceMappingURL=AutoCallInteraction.js.map